type Props = {
  fill?: string;
  height?: string;
  width?: string;
};

const ClockIcon = ({ fill = 'black', width = '24', height = '24' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke={fill} strokeWidth="2" />
      <rect x="11" y="6" width="2" height="8" rx="1" fill={fill} />
      <rect
        x="16.75"
        y="15"
        width="2"
        height="6"
        rx="1"
        transform="rotate(123.134 16.75 15)"
        fill={fill}
      />
    </svg>
  );
};

export default ClockIcon;
